export default __webpack_public_path__ + "static/media/Look Across.0a42f901.jpg";